export default __webpack_public_path__ + "static/media/shoppinglist_male.ba3956af.png";